import { render } from "./ModalPhoneRegistration.vue?vue&type=template&id=2a3ef0ba"
import script from "./ModalPhoneRegistration.vue?vue&type=script&lang=js"
export * from "./ModalPhoneRegistration.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__